import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import {Component, Inject} from "@angular/core";
import {faCoffee, faWifi} from "@fortawesome/pro-regular-svg-icons";

// ...

@Component({
    selector: '...',
    templateUrl: './icon-snack-bar.component.html',
})
// Most likely you have to add styles in order to position the icon, although I haven't tested it yet
export class IconSnackBarComponent {

    faCoffee = faWifi;
    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {



    }
}
